import ChatMessage from "@src/types/ChatMessage";
import {Toast} from "@src/plugins/toast";

const baseUrl = (import.meta.env.VITE_DCHAT_URL as string) ?? '';

// Baixa o arquivo via fetch+blob pra forçar o download real (em vez de
// abrir/navegar), o que exige que o servidor libere CORS pra essa origem.
// Se o fetch falhar (CORS, rede, etc.), caímos pra abrir a URL numa nova
// aba como alternativa — pior experiência, mas pelo menos algo funciona.
export const downloadFile = async (url: string | null | undefined): Promise<void> => {
    if (!url) return
    const filename = url.split('/').pop()?.split('?')[0] ?? 'download'

    try {
        const response = await fetch(url)
        if (!response.ok) throw new Error(`HTTP ${response.status}`)

        const blob = await response.blob()
        const objectUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = objectUrl
        a.download = filename
        a.click()
        URL.revokeObjectURL(objectUrl)
    } catch (e) {
        console.error('[download] failed to fetch file, falling back to opening url:', e)
        Toast.fire('Não foi possível baixar o arquivo diretamente', 'Abrindo em uma nova aba...', 'warning')
        window.open(url, '_blank')
    }
};

export const resolveUrl = (url: string | null | undefined): string => {
    if (!url) return '';
    return url.startsWith('http') ? url : `${baseUrl.replace(/\/$/, '')}/${url.replace(/^\//, '')}`;
};

export const shorten = (message: ChatMessage|string, maxLength: number = 23) => {
    let text: string | undefined;
    if(!message) {
        return ''
    }
    if (typeof message === "string") {
        text = message;
    } else {
        text = message.message;
    }

    if (text) {
        text = text.replace(/<br\s*\/?>/gi, '\n');
        const newlineIndex = text.indexOf('\n');
        const cutAt = newlineIndex !== -1 ? Math.min(maxLength, newlineIndex) : maxLength;
        if (text.length > cutAt || newlineIndex !== -1) {
            return text.slice(0, cutAt) + "...";
        }
        return text;
    }

    return "";
};